import { Form } from "antd";
import { CustomButton } from "@Components/Button";
import FormItem from "@Components/FormItem/FormItem";
import AuthCard from "@Components/AuthCard";
import useLoginContainer from "./useContainerLogin";

const Login = () => {
  const { handleSubmit, isLoggingIn, form, navigate } = useLoginContainer();

  return (
    <div className="w-full">
      <AuthCard
        maxWidth="532px"
        minHeight="auto"
        title="Welcome to Story Tree"
        description="Enter your email address and password to login."
      >
        <Form
          form={form}
          initialValues={{ isRemember: false, email: null, password: null }}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <FormItem
            name="email"
            labelClassName="font-medium"
            rules={[
              { required: true, message: "Please enter your email" },
              {
                pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Please enter a valid email address",
              },
            ]}
            inputConfig={{
              label: "Email",
              placeholder: "Enter email",
              type: "email",
            }}
            className="!border border-strokeBorder rounded-[14px] mb-4"
          />

          <FormItem
            name="password"
            rules={[
              { required: true, message: "Please enter your password" },
              
            ]}
            inputConfig={{
              label: "Password",
              isPassword: true,
              placeholder: "Enter password",
            }}
            className="!border border-strokeBorder rounded-[14px] mb-4"
          />

          <div className="flex items-center justify-end mb-6">
            <span
              className="!text-sm !text-[#575757] !font-medium !font-Nunito cursor-pointer hover:underline"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot Password
            </span>
          </div>

          <Form.Item>
            <CustomButton
              title="Login"
              htmlType="submit"
              type="primary"
             className="w-full mb-4 h-14 !bg-primaryGreen rounded-xl !font-semibold !tracking-wide !font-Nunito disabled:!bg-primaryGreen disabled:!opacity-100 disabled:!text-white disabled:!cursor-not-allowed"
              disabled={isLoggingIn}
              isLoading={isLoggingIn}
            />
          </Form.Item>
        </Form>
      </AuthCard>
    </div>
  );
};

export default Login;
